const AlertIds = {
    REPORTS_MENU_TOOLTIP: 1001,
    PAYMENTS_MENU_TOOLTIP: 999,
    TNCP_POPUP: 40171,
    AVALOQ_DOWNTIME: 486
}

const ActionDetails = {
    DO_NOT_SHOW: "Do No Show Again Clicked"
}

const DisplayType = {
    TOOLTIP: "TOOLTIP",
    POPUP: "POPUP",
    BANNER: "BANNER"
}

const AlertDocName = {
    TNC: 'Terms and Conditions',
    PRIVACY: 'Privacy'
}

const AlertsMap = {
    [AlertIds.REPORTS_MENU_TOOLTIP]: {
       
        detailsAction: {
            label:'app.common.pageTitle.reports',
            detailsActionComponent: '/reports',
        },
        doNotShowAgain: true,
        targetFeature: 'Reports'   
    },
    [AlertIds.PAYMENTS_MENU_TOOLTIP]: {
       
        detailsAction: {
            label:'app.common.pageHeader.Payments',
            detailsActionComponent: '/payments',
        },
        doNotShowAgain: true,
        targetFeature: 'Payments'
    },
    [AlertIds.AVALOQ_DOWNTIME]: {
       
        detailsAction: {
            label:'',
            detailsActionComponent: '',
        },
        doNotShowAgain: true,
        targetFeature: ''
    }
 
}
 
export {
    AlertIds,
    AlertsMap,
    ActionDetails,
    DisplayType,
    AlertDocName
}